import 'ace-builds';
import htmlModeUrl from 'file-loader?esModule=false&name=scripts/ace/[name].[ext]!ace-builds/src-noconflict/mode-html.js';
import htmlWorkerUrl from 'file-loader?esModule=false&name=scripts/ace/[name].[ext]!ace-builds/src-noconflict/worker-html.js';
import velocityModeUrl from 'file-loader?esModule=false&name=scripts/ace/[name].[ext]!ace-builds/src-noconflict/mode-velocity.js';
import propertiesModeUrl from 'file-loader?esModule=false&name=scripts/ace/[name].[ext]!ace-builds/src-noconflict/mode-properties.js';
import cssModeUrl from 'file-loader?esModule=false&name=scripts/ace/[name].[ext]!ace-builds/src-noconflict/mode-css.js';
import cssWorkerUrl from 'file-loader?esModule=false&name=scripts/ace/[name].[ext]!ace-builds/src-noconflict/worker-css.js';
import htmlSnippetsUrl from 'file-loader?esModule=false&name=scripts/ace/[name].[ext]!ace-builds/src-noconflict/snippets/html.js';
import velocitySnippets from 'file-loader?esModule=false&name=scripts/ace/[name].[ext]!ace-builds/src-noconflict/snippets/velocity.js';
import propertiesSnippets from 'file-loader?esModule=false&name=scripts/ace/[name].[ext]!ace-builds/src-noconflict/snippets/properties.js';
import cssSnippets from 'file-loader?esModule=false&name=scripts/ace/[name].[ext]!ace-builds/src-noconflict/snippets/css.js';
import type {edit, require, config} from 'ace-builds';

declare global {
    interface Window {
        ace: {edit: typeof edit, config: typeof config, require: typeof require};
    }
}
// TODO: move config to ace editor file
window.ace.config.setModuleUrl('ace/mode/html', htmlModeUrl);
window.ace.config.setModuleUrl('ace/mode/html_worker', htmlWorkerUrl);
window.ace.config.setModuleUrl('ace/mode/velocity', velocityModeUrl);
window.ace.config.setModuleUrl('ace/mode/properties', propertiesModeUrl);
window.ace.config.setModuleUrl('ace/mode/css', cssModeUrl);
window.ace.config.setModuleUrl('ace/mode/css_worker', cssWorkerUrl);
window.ace.config.setModuleUrl('ace/snippets/html', htmlSnippetsUrl);
window.ace.config.setModuleUrl('ace/snippets/velocity', velocitySnippets);
window.ace.config.setModuleUrl('ace/snippets/properties', propertiesSnippets);
window.ace.config.setModuleUrl('ace/snippets/css', cssSnippets);
